/**
 * For display plan information
 * @export
 * @class PlanDefaultInfo
 */


export default class PlanDefaultInfo {
  public id: string = ''
  public name: string = ''
  public price: number = 0

  public constructor(fields?: {
    id?: string,
    name?: string,
    price?: number,
  }) {
    if (fields) {
      Object.assign(this, fields)
    }
  }
}
